import React, { FC, Suspense, useCallback, useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import LazyLoad from 'react-lazyload';
import { useMedia } from 'react-use';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Skeleton from 'react-loading-skeleton';
import VideoThumbnail from '../../scenes/common/SceneRef';
import { MovieModel } from '../types';
import { SceneItemModel } from '../../scenes/common/SceneItem/types';
import CoverFlags from '../../movies/common/CoverFlags';
import GermanAudio from '@images/german-audio.png';
import PlayIcon from '@images/red-play-icon.png';


type Props = {
  item: MovieModel & SceneItemModel;
  coverScene?: boolean;
  type: 'movies' | 'scenes';
  index?: number
  id?: number | string
  rawType?: string
  swiperActiveId?: number
};

const Item: FC<Props> = ({ item, type, coverScene, index, id, rawType, swiperActiveId }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [showVideo, setShowVideo] = useState(false);
  const [imageIndex, setImageIndex] = useState(0);
  const isMobile = useMedia('(max-width: 640px)');
  const history = useHistory();

  const thumbnails = item.thumbnails.static ? item.thumbnails.static : item.thumbnails;
  const video = item.thumbnails.video;
  const gif = item.thumbnails.gif;
  const isScene = type === 'scenes';
  const isMovie = type === 'movies';

  let url = `/${isMovie ? 'movie' : 'scene'}/${item.id}`;
  const title = isMovie ? item.title : item?.movie_title;

  if (isMovie && title) url = `${url}/${title.replace(/ /g, '-').replace(/[^\w-]+/g, '')}`;

  const changeImageSrc = useCallback(
    (data: SceneItemModel) => {
      setTimeout(() => {
        if (data?.thumbnails?.gif && imageIndex >= data?.thumbnails?.gif?.length - 1) {
          setImageIndex(0);
        } else {
          setImageIndex(imageIndex + 1);
        }
      }, 1000);
    },
    [imageIndex],
  );

  useEffect(() => {
    if (showVideo && item?.thumbnails?.gif && item?.thumbnails?.gif?.length > 0) {
      changeImageSrc(item);
    } else if (showVideo) setImageIndex(0);
  }, [showVideo, imageIndex, item, changeImageSrc]);

  const openItem = useCallback(() => {
    if (isMobile && !coverScene) setShowVideo(s => !s);
    sessionStorage.setItem('homeScrollContent', `${item.id}`);
    sessionStorage.setItem('homeScrollContentId', `${id ? id : rawType}`);
    sessionStorage.setItem('homeScrollSwiperId', `${swiperActiveId}`);
    history.push(url);
  }, [isMobile, coverScene, history, url, item, id, rawType, swiperActiveId]);

  return (
    <Suspense fallback={
      <div className="w-full item-slider">
        <Skeleton height="100%" width="100%" />
      </div>
    }>
      <div
        className={`poster-list-item-recommended cursor-pointer relative w-full h-full`}
        role={'button'}
        onMouseEnter={() => setShowVideo(isMobile && !coverScene ? false : true)}
        onMouseLeave={() => setShowVideo(false)}
        onClick={openItem}
        onKeyPress={openItem}
        tabIndex={index || 1}
      >
        <div className={'hover-effect-container'}>
          <div className={'hover-effect'}></div>
          <div className={'play-icon'}>
            <div className="play-icon-container">
              <LazyLoadImage src={PlayIcon} alt="play button icon" className="w-full" />
            </div>
          </div>
          <div className="recomended-poster-item-title font-semibold">
            {title || ''}
          </div>
        </div>
        <div
          className={isScene ? `carousel-scene relative cursor-pointer flex flex-1 h-full` : 'cover-image w-full h-full'}>
          {isScene && item.needs_play_button === 1 && !coverScene && (
            <div className="absolute z-10 top-0 pointer-events-none w-full h-full">
              <img className="scene4-3__play-button" src={PlayIcon} alt="Play icon" />
            </div>
          )}
          <LazyLoad height={200}>
            <picture style={isScene ? { paddingBottom: '0px' } : undefined}
                     className="poster-icon w-full duration-200 h-full" onLoad={() => setIsLoaded(true)}>
              <source
                media="(max-width: 640px)"
                srcSet={thumbnails?.large ? thumbnails.large : thumbnails?.original ? thumbnails.original : ''}
              />
              <source
                media="(min-width: 641px) and (max-width: 1023px)"
                srcSet={thumbnails?.large ? thumbnails.large : thumbnails?.original ? thumbnails.original : ''}
              />
              <source
                media="(min-width: 1024px)"
                srcSet={thumbnails?.large ? thumbnails.large : thumbnails?.original ? thumbnails.original : ''}
              />

              <LazyLoadImage style={isScene ? { paddingBottom: '0px' } : undefined} src={thumbnails?.original || ''}
                             className={`${isScene && showVideo ? ' hidden' : ''}`} alt="movie poster" />
            </picture>
          </LazyLoad>
          {isScene && (
            <>
              {video ? (
                <LazyLoad>
                  <VideoThumbnail src={video} showVideo={showVideo} thumb={thumbnails.original} />
                </LazyLoad>
              ) : null}
              <LazyLoad height={200}>
                {gif ? <LazyLoadImage
                  src={gif && gif[imageIndex]?.url}
                  alt="scene poster"
                  className={`w-full duration-200 ${isScene && !video && showVideo ? 'block' : 'hidden'}`}
                /> : null}
              </LazyLoad>
            </>
          )}

          {/*      {item.needs_icon && isLoaded ? (
          <div className="german-audio">
            <LazyLoadImage src={GermanAudio} alt="german audio icon" className="w-full" />
          </div>
        ) : null}*/}
          {/*{isLoaded && !isScene ? (
          <div className="play-icon-container">
            <LazyLoadImage src={PlayIcon} alt="play button icon" className="w-full" />
          </div>
        ) : null}*/}
        </div>
        <CoverFlags data={item} isLoaded={isLoaded} />
        {/*{title && isMovie && isLoaded ? (
        <div className="recomended-poster-item-bottom-info text-md leading-3 pt-2">
          <Link to={url} title={title}>
            <span className="work-sans-font text-mainRed" title={title}>
              {title || ''}
            </span>
          </Link>
        </div>
      ) : (
        ''
      )}*/}
      </div>
    </Suspense>
  );
};

export default Item;
